import './App.css';
import SectionFacilities from './components/SectionFacilities';
import SectionAskDoctors from './components/SectionAskDoctors';

function App() {
  return (
    <>
      <SectionFacilities />
      <SectionAskDoctors />
    </>
  )
}

export default App;
